import React, { useCallback, useEffect, useState } from 'react';
import useForm from '@ui/forms/use-form';
import FormHtmlInput from '@ui/forms/form-input';
import { buildInput } from '@ui/forms/use-form';
import GooglePlaces from '@ui/google-places';

const FormAddress = ({ name, data, initValues, onFormStateChanged }) => {
    const [manualAddress, setManualAddress] = useState(false);
    const [fullAddress, setFullAddress] = useState(null);
    const [isAddressTouched, setAddressTouched] = useState(false);

    const introText = data.introText;
    var inputs = [
        buildInput(data.unitNumber, initValues.unitNumber),
        buildInput(data.streetNumber, initValues.streetNumber),
        buildInput(data.streetName, initValues.streetName),
        buildInput(data.suburb, initValues.suburb),
        buildInput(data.state, initValues.state),
        buildInput(data.postcode, initValues.postcode),
    ];

    var form = useForm({
        inputs: inputs,
        onSubmit: (values) => {},
    });

    useEffect(() => {
        const hasUnitNumber =
            initValues.unitNumber !== null &&
            initValues.unitNumber !== undefined;
        const streetWithUnit = hasUnitNumber
            ? `${initValues.unitNumber}/${initValues.streetNumber}`
            : initValues.streetNumber;
        const fullAddress = initValues.streetName
            ? `${streetWithUnit} ${initValues.streetName} ${
                  initValues.suburb
              }, ${initValues.state?.toUpperCase()} ${initValues.postcode}`
            : '';

        setFullAddress(fullAddress);
    }, []);

    useEffect(() => {
        if (onFormStateChanged) {
            onFormStateChanged(form);
        }
    }, [form.isValid, form.values]);

    const handleAddressChanged = useCallback((value) => {
        form.setValues({
            unitNumber: value.unit,
            streetNumber: value.streetNumber,
            streetName: value.streetName,
            suburb: value.suburb,
            postcode: value.postcode,
            state: value.stateShort?.toLowerCase(),
        });
    }, []);

    const handleManualAddressClicked = useCallback(
        (e) => {
            e.preventDefault();
            setManualAddress(!manualAddress);
        },
        [manualAddress]
    );

    const isAddressValid = () => {
        if (!isAddressTouched) return true;
        return (
            !form.errors.unit &&
            !form.errors.streetNumber &&
            !form.errors.streetName &&
            !form.errors.suburb &&
            !form.errors.postcode &&
            !form.errors.state
        );
    };

    return (
        <div>
            {introText?.length > 0 && (
                <p className="font-bold mt-9">{introText}</p>
            )}

            <div className="flex flex-col gap-6">
                <div className={manualAddress ? `hidden` : 'mt-3'}>
                    <GooglePlaces
                        name={name}
                        placeholder={
                            data.placeholderForSearchInput ??
                            'Enter your address'
                        }
                        countries={data.countriesToScopeSearch}
                        onPlaceChanged={handleAddressChanged}
                        defaultValue={fullAddress}
                        onBlur={(e) => {
                            setAddressTouched(true);
                        }}
                        error={
                            isAddressValid() ? '' : 'Please enter your address'
                        }
                    />
                    <a
                        href="#"
                        onClick={handleManualAddressClicked}
                        className="text-skin-primary text-xs"
                    >
                        Enter address manually
                    </a>
                </div>
                <div
                    className={
                        manualAddress ? `flex flex-col gap-6 mt-6` : `hidden`
                    }
                >
                    <FormHtmlInput data={data.unitNumber} form={form} />
                    <FormHtmlInput data={data.streetNumber} form={form} />
                    <FormHtmlInput data={data.streetName} form={form} />
                    <FormHtmlInput data={data.suburb} form={form} />
                    <FormHtmlInput data={data.state} form={form} />
                    <FormHtmlInput data={data.postcode} form={form} />
                </div>
            </div>
        </div>
    );
};

export default FormAddress;
